import React from 'react';
import './Offices.css';

const officeLocations = [
  { city: 'San Mateo', address: '100 S. Ellsworth Ave, Suite 900, San Mateo, California 94401 USA' },
  { city: 'Seoul', address: '17F, 514, Seolleung-ro, Gangnam-gu, Seoul, Republic of Korea 06162' },
  { city: 'Singapore', address: 'Level 17, Frasers Tower, 182 Cecil Street, Singapore 069547' }
];

function Offices() {
  return (
    <section className="offices-section container">
      <div className="offices-image-container">
        <img src="https://sendbird.imgix.net/cms/Frame-1000008620.svg" alt="World Map with office locations" className="offices-map-image"/>
      </div>
      <div className="offices-info">
        <h3 className="offices-main-title">Our offices</h3>
        <div className="offices-list">
          {officeLocations.map((office, index) => (
            <div key={index}>
              <div className="office-item">
                <p className="office-city">{office.city}</p>
                <p className="office-address">{office.address}</p>
              </div>
              {index < officeLocations.length - 1 && <hr className="office-divider" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Offices;